import React, { useEffect, useState } from 'react'
import request from '../../../../utils/request';
import AssetListItem from './AssetListItem';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectDataListSectionIds, selectEndorsmentFormData, selectEndorsmentScreenNumber } from 'src/features/rfqDataSlice';
import AddNewHeaderBox from '../AddNewHeaderBox';
import { Settings } from "@mui/icons-material";


function AssetList({ sumInsuredData, productId }) {
  const [assetGroups, setAssetGroups] = useState([]);
  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const endorsementScreenNumber = useSelector(selectEndorsmentScreenNumber);
  const [openAddNewHeaderBox, setOpenAddNewHeaderBox] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const sectionData = endorsementFormData?.sumInsuredSectionData?.[sumInsuredData?.id];
  const hasGroupsForScreen2 =    Object.keys(sectionData?.groups || {}).length > 0;
  const hasFireFloaterSelection = sectionData?.fireFloaterData?.istotalSumInsuredSelected || sectionData?.fireFloaterData?.isfireFloaterOccupancySelected;

  const shouldRenderHeader = (endorsementScreenNumber === 1 && assetGroups.length > 0) || (endorsementScreenNumber === 2 && (hasGroupsForScreen2 || hasFireFloaterSelection));
  const closeAddNewHeaderBox = () => {
    setOpenAddNewHeaderBox(false);
  }
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    fetchEmpGroups();
  }, [])

  const fetchEmpGroups = () => {

    request({
      url: '/insurancePolicy/getSumInsuredListGroups',
      method: 'post',
      data: {
        policyId: sumInsuredData.policyId,
        sectionId: sumInsuredData.id
      }
    }).then(
      (response: any) => {

        setAssetGroups(response.data);
        if (response.data.length > 0) {
          let sumInsuredBox = document.getElementById('sumInsuredBox');
          if (sumInsuredBox) { sumInsuredBox.style.display = 'block' }
        }
      },
      (error) => {
        console.log(error);

      }
    );
  }



  return (
    <>

      {shouldRenderHeader && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            mt: "10px",
            mb: "5px",
            p: "6px",
            background: "rgb(9, 84, 174)",
            color: "#fff",
            borderRadius: "4px",
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            className="heading"
            component="div"
            sx={{ fontWeight: "bold" }}
          >
            {sumInsuredData?.sectionName}
          </Typography>

          {endorsementScreenNumber === 1 && (
            <>
              <IconButton
                onClick={handleOpenMenu}
                sx={{ color: "#fff", padding: 0 }}
              >
                <Settings />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={() => {
                    setOpenAddNewHeaderBox(true);
                    handleCloseMenu();
                  }}
                >
                  Add Headers
                </MenuItem>
              </Menu>
            </>
          )}
        </Box>
      )}
      {
        assetGroups.length > 0 &&
        assetGroups.map((group) => (
          <AssetListItem
            key={group.id}
            sumInsuredData={sumInsuredData}
            groupDetails={group}
            policyId={sumInsuredData.policyId}
            productId={productId}
          />
        ))
      }

      {openAddNewHeaderBox && <AddNewHeaderBox sumInsuredData={sumInsuredData} onClose={closeAddNewHeaderBox} />}

    </>
  );
}

export default AssetList